<template>
  <div v-show="show" class="csgo-mask flex flex-ac flex-jc">
    <!-- 背景光晕装饰 -->
    <div class="bg-light fixed inset-0 pointer-events-none overflow-hidden">
      <div class="ball ball-1"></div>
      <div class="ball ball-2"></div>
      <div class="ball ball-3"></div>
    </div>

    <!-- 倒计时弹窗 -->
    <div class="modal-glass">
      <div class="count-text" :class="{ animateIn: showAnim, pulseStart: isStart }">
        {{ countText }}
      </div>
    </div>
    <audio controls ref="notify4" class="audio">
      <source src="@/assets/audio/count_volume_10.mp3" />
    </audio>
  </div>
</template>

<script>
export default {
  name: 'CountGame',
  data() {
    return {
      show: false,
      countText: '3',
      showAnim: true,
      isStart: false,
      countList: [3, 2, 1],
      index: 0
    }
  },
  mounted() {
    // setTimeout(this.nextCount, 300)
  },
  methods: {
    toggle() {
      this.index = 0
      this.show = true
      this.$refs.notify4.currentTime = 0
      this.$refs.notify4.volume = 0.1
      this.$refs.notify4.play()
      this.nextCount()
    },
    nextCount() {
      if (this.index < this.countList.length) {
        // 关闭动画，重绘后切换数字再开动画
        this.showAnim = false
        setTimeout(() => {
          this.countText = this.countList[this.index]
          this.showAnim = true
          this.index++
          setTimeout(this.nextCount, 1000)
        }, 50)
      } else {
        // 倒计时结束，显示游戏开始+呼吸动画
        this.showAnim = false
        setTimeout(() => {
          this.countText = '游戏开始'
          this.showAnim = true
          this.isStart = true
          setTimeout(() => {
            this.show = false
            this.$refs.notify4.pause()
            this.$emit('game-start')
          }, 1500)
          // 这里可派发事件通知父组件游戏启动
        }, 50)
      }
    }
  }
}
</script>

<style scoped>
/* 全局页面容器 */
.page-wrap {
  min-width: 100vw;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  z-index: 111;
  /* background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #312e81 100%); */
  overflow: hidden;
}

/* 玻璃弹窗 */
.modal-glass {
  /* background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 1rem;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.35); */
  position: relative;
  z-index: 10;
  /* 手机内边距 */
  padding: 2rem 1rem;
}
@media (min-width: 768px) {
  .modal-glass {
    padding: 2rem 1rem;
  }
}

/* 倒计时文字 响应式字号 */
.count-text {
  font-family: 'Montserrat', sans-serif;
  font-weight: 900;
  background: linear-gradient(90deg, #6366f1, #ec4899);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: center;
  white-space: nowrap;
  user-select: none;
  font-size: 5rem;
}
@media (min-width: 640px) {
  .count-text {
    font-size: 5rem;
  }
}
@media (min-width: 768px) {
  .count-text {
    font-size: 6rem;
  }
}

/* 入场弹出动画 */
.animateIn {
  animation: bigIn 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
/* 游戏开始呼吸缩放动画 */
.pulseStart {
  animation: pulseScale 1s ease-in-out infinite;
}

@keyframes bigIn {
  0% {
    transform: scale(3);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes pulseScale {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.15);
    opacity: 1;
  }
}

/* 背景模糊光晕 */
.ball {
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.2;
  position: absolute;
}
.ball-1 {
  width: 10rem;
  height: 10rem;
  background: #6366f1;
  top: 10%;
  left: 15%;
}
.ball-2 {
  width: 14rem;
  height: 14rem;
  background: #ec4899;
  bottom: 20%;
  right: 10%;
}
.ball-3 {
  width: 7rem;
  height: 7rem;
  background: #818cf8;
  top: 60%;
  left: 70%;
}
@media (min-width: 768px) {
  .ball-1 {
    width: 15rem;
    height: 15rem;
    filter: blur(100px);
  }
  .ball-2 {
    width: 20rem;
    height: 20rem;
    filter: blur(120px);
  }
  .ball-3 {
    width: 10rem;
    height: 10rem;
    filter: blur(80px);
  }
}
.audio {
  display: none;
}
</style>